"use strict";

var _interopRequireWildcard = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _user = require("@/api/user");
var _auth = require("@/utils/auth");
var _router = _interopRequireWildcard(require("@/router"));
var state = {
  token: (0, _auth.getToken)(),
  info: {},
  roles: ['admin']
};
var mutations = {
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_INFO: function SET_INFO(state, info) {
    state.info = info;
  },
  SET_ROLES: function SET_ROLES(state, roles) {
    state.roles = roles;
  }
};
var actions = {
  // user login
  login: function login(_ref, userInfo) {
    var commit = _ref.commit;
    var username = userInfo.username,
      password = userInfo.password;
    return new Promise(function (resolve, reject) {
      (0, _user.login)({
        username: username.trim(),
        password: password
      }).then(function (response) {
        var data = response.data;
        commit('SET_TOKEN', data.token);
        (0, _auth.setToken)(data.token);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // get user info
  getInfo: function getInfo(_ref2) {
    var commit = _ref2.commit;
    return new Promise(function (resolve, reject) {
      (0, _user.getInfo)().then(function (response) {
        var data = response.data;
        if (!data) {
          reject('Verification failed, please Login again.');
        }
        commit('SET_INFO', data);
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // user logout
  logout: function logout(_ref3) {
    var commit = _ref3.commit;
    commit('SET_TOKEN', '');
    commit('SET_ROLES', []);
    (0, _auth.removeToken)();
    (0, _router.resetRouter)();
  },
  // remove token
  resetToken: function resetToken(_ref4) {
    var commit = _ref4.commit;
    return new Promise(function (resolve) {
      commit('SET_TOKEN', '');
      commit('SET_ROLES', []);
      (0, _auth.removeToken)();
      resolve();
    });
  },
  // dynamically modify permissions
  changeRoles: function changeRoles(_ref5, role) {
    var commit = _ref5.commit,
      dispatch = _ref5.dispatch;
    return new Promise( /*#__PURE__*/function () {
      var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(resolve) {
        var token, _yield$dispatch, roles, accessRoutes;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              token = role + '-token';
              commit('SET_TOKEN', token);
              (0, _auth.setToken)(token);
              _context.next = 5;
              return dispatch('getInfo');
            case 5:
              _yield$dispatch = _context.sent;
              roles = _yield$dispatch.roles;
              (0, _router.resetRouter)();

              // generate accessible routes map based on roles
              _context.next = 10;
              return dispatch('permission/generateRoutes', roles, {
                root: true
              });
            case 10:
              accessRoutes = _context.sent;
              // dynamically add accessible routes
              _router.default.addRoutes(accessRoutes);

              // reset visited views and cached views
              dispatch('tagsView/delAllViews', null, {
                root: true
              });
              resolve();
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref6.apply(this, arguments);
      };
    }());
  }
};
var _default = exports.default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};